import Input from "components/page/user/contract/edit/input/inputNormal";
import { BlockBase, HeadlineHeader } from "components/page/user/contract/edit/parts/blockBase";
import { SEND_OTHER_PAPER } from "constants/messages";
import React from "react";
import { Link } from "react-router-dom";
import Validation from "util/validate";
import InputTextRemark from "../../input/inputTextRemark";

/** 取引条件 */
export default class Block1 extends BlockBase {
    constructor(props) {
        super(props);
        this.state = {
            ...this.state,
            headlineId: "021201",
        };
        // 入力値のチェック用オブジェクトを生成
        this.validation = new Validation();
    }

    /** 削除ボタンのハンドラ */
    handleDeleteJYU01086 = e => {
        this.handleDelete(e, "JYU01086_ARR");
    }

    /** 追加ボタンのハンドラ */
    handleAddJYU01086 = e => {

        const addObj = {
            JYU01086: undefined, // 授受の目的 名称
            JYU01087: undefined, // 授受の目的 金額
            JYU01089: undefined, // 授受の目的 備考
        };

        this.handleAdd(e, "JYU01086_ARR", addObj);
    }

    render() {
        const { hideBlockClass, params } = this.renderCommon();

        //JYU01100の入力上限判定
        const JYU01100LimitErrorMessage = this.validation.validateTextAreaWordCount(`JYU01100_${this.props.displayTypeID}`, this.props.pageState.JYU01100);

        // 非表示判定の場合、null(react的な表示なし)を返す
        if (this.dohide(this.props.pageState.hidingHeadline)) { return null; }

        const arrayItemsDOM = this.createDOMItems(this.props.pageState.JYU01086_ARR, this.props.pageState.TOR00011);

        return (
            <div className={`dataList dataList__accordion ${hideBlockClass}`}>
                <div className="dataList-header">
                    <div className="dataList-header-title">取引条件</div>
                    <HeadlineHeader onClick={this.handleHide} hide={this.state.hide} />
                </div>
                <div className="dataList-body">
                    <table className="dataTable">
                        <tbody>
                            <tr>
                                <td className="dataTable-body is-emphasis dataTable-body__noborder" colSpan="5">
                                    <div className="dataTableUnit dataTableUnit--center">
                                        <div className="dataTableUnit-text">売買代金</div>
                                        <div className="dataTableUnit-text">{this.amountCommaEdit(this.props.pageState.TOR00010)}</div>
                                        <div className="dataTableUnit-text">円</div>
                                        <div className="dataTableUnit-text">（うち消費税等相当額</div>
                                        <div className="dataTableUnit-text">{this.amountCommaEdit(this.props.pageState.TOR00009)}</div>
                                        <div className="dataTableUnit-text">円）</div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th className="dataTable-title is-emphasis_single" colSpan="5">売買代金および交換差金以外に売主・買主間で授受される金銭の額</th>
                            </tr>
                            {arrayItemsDOM}
                            <tr>
                                <th className="dataTable-title dataTable-title__w120 dataTable-title__center">備考</th>
                                <td className="dataTable-body" colSpan="4">
                                    <div className="dataTableTextUnit">
                                        <InputTextRemark id="ID_JYU01100" name="JYU01100" value={this.props.pageState.JYU01100} text={SEND_OTHER_PAPER.JYU01100} placeholder={JYU01100LimitErrorMessage.inputLimitGuide} {...params} />
                                        <p className="LengthOver-error">{JYU01100LimitErrorMessage.inputLimitErrorMessage}</p>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }

    createDOMItems = (arrays, tor00011) => {
        // 動的項目の共通パラメータ
        const arrayName = "JYU01086_ARR"; // 動的項目の代表名
        const params = {
            arrayName: arrayName,
            pageState: this.props.pageState,
            updatePageState: this.props.updatePageState,
        };

        const arrayItemsDOM = arrays.map((item, idx) => {

            // "通番"部分生成
            let head = null;
            if (idx === 0 || idx === 1) {
                // 1番目、2番目は表示固定なので削除できない
                head = <th className="dataTable-title dataTable-title__center" rowSpan="2">{idx + 1}</th>;

            } else {
                // 3番目以降は削除ボタンを付ける
                head = (
                    <th className="dataTable-title dataTable-title__center" rowSpan="2">
                        <div className="dataTable-title-vr">{idx + 1}</div>
                        <div className="dataTable-title-vr">
                            <Link to="" id={`LINK_DEL_JYU01086_ARR_${idx}`} aria-label="link" data-idx={idx} data-array-name={arrayName} className="baseAction baseAction--minus baseAction__w40" onClick={this.handleDeleteJYU01086}>
                                <span data-idx={idx} className="baseAction-text">削除</span>
                            </Link>
                        </div>
                    </th>
                );
            }

            // "授受の目的"部分の生成
            let item1 = null;
            if (idx === 0 || idx === 1) {
                // 1番目、2番目は入力欄にならない
                item1 = <td className="dataTable-body">{item.JYU01086}</td>;

            } else {
                item1 = (
                    // 3番目以降は入力欄になる
                    <td className="dataTable-body">
                        <Input idx={idx} mode="dynamic" id={`ID_JYU01086_${idx}`} name="JYU01086" value={item.JYU01086} {...params} />
                    </td>
                );
            }
            // "金額"部分の生成
            let item2 = null;
            if (idx === 0) {
                // 1番目（手付金）は別入力項目参照
                item2 = <div className="dataTableUnit-text">{this.amountCommaEdit(tor00011)}</div>;
            } else {
                // 2番目以降は入力欄になる
                item2 = <Input idx={idx} mode="dynamic" id={`ID_JYU01087_${idx}`} name="JYU01087" value={item.JYU01087} {...params} />;
            }

            return (
                <React.Fragment key={idx} >
                    <tr>
                        {head}
                        <th className="dataTable-title dataTable-title__center">授受の目的</th>
                        {item1}
                        <th className="dataTable-title dataTable-title__center">金額</th>
                        <td className="dataTable-body">
                            <div className="dataTableUnit">
                                {item2}
                                <div className="dataTableUnit-text">円</div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th className="dataTable-title dataTable-title__center">備考</th>
                        <td className="dataTable-body" colSpan="2">
                            <Input idx={idx} mode="dynamic" id={`ID_JYU01089_${idx}`} name="JYU01089" value={item.JYU01089} {...params} />
                        </td>
                        <td className="dataTable-body">&nbsp;</td>
                    </tr>
                </React.Fragment>
            );
        });

        return (
            <React.Fragment>
                {arrayItemsDOM}
                <tr>
                    <td className="dataTable-body dataTable-body__center" colSpan="5">
                        <Link to="" id="LINK_ADD_JYU01086_ARR" aria-label="link" data-array-name={arrayName} className="baseAction baseAction--plus baseAction__w40" onClick={this.handleAddJYU01086}>
                            <span className="baseAction-text">追加</span>
                        </Link>
                    </td>
                </tr>
            </React.Fragment>
        );
    }
}